module.exports = __webpack_public_path__ + "img/sg.2255e54e.svg";